import { gql, useMutation } from "@apollo/client";

const CONTACT_AGENT_MUTATION = gql`
  mutation contact_expert($input: ContactAgentInput!) {
    contact_expert(input: $input) {
      ... on ContactAgentResult {
        recipients {
          name
        }
      }
      ... on ContactAgentErrors {
        errors {
          type
          messages
        }
      }
    }
  }
`;

const useContactAgentMutation = () => useMutation(CONTACT_AGENT_MUTATION);

export default useContactAgentMutation;
